export default {
    select: "Seleccionar dirección de envío",
    shippingRulesTip: "Tienes que seguir las reglas locales para el envío."
}